/** Terminals allowed to use Pickup Assignment V2. */
export const PICKUP_ASSIGNMENT_V2_ALLOWED_TERMINAL_IDS: number[] = [
  1, 209, 4, 153, 611, 863, 189, 109, 384,
];

export function isPickupAssignmentV2Allowed(terminalId: number | undefined): boolean {
  return terminalId != null && PICKUP_ASSIGNMENT_V2_ALLOWED_TERMINAL_IDS.includes(terminalId);
}
